import React, { useState } from "react";
import { Tabs, Tab, Box, Paper } from "@mui/material";
import UserInfo from "./UserInfo";
import ChangePassword from "./ChangePassword";

const Profile = () => {
  const [activeTab, setActiveTab] = useState(0);
  const user = JSON.parse(localStorage.getItem("user") ?? "{firstName:'', lastName: '', timezone:'', email: ''}"); 

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Paper elevation={3} sx={{ padding: 3, maxWidth: 600, margin: "0 auto", marginTop: 5 }}>
      <Tabs value={activeTab} onChange={handleTabChange} centered>
        <Tab label="User Info" />
        <Tab label="Change Password" />
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        <UserInfo user={user} />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <ChangePassword />
      </TabPanel>
    </Paper>
  );
};

const TabPanel = ({ children, value, index }) => {
  return value === index && <Box sx={{ padding: 3 }}>{children}</Box>;
};

export default Profile;
